import { makeStyles } from "@material-ui/core";
import {
  Button,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  DialogActions,
  Typography,
  Card,
  SvgIcon,
  IconButton,
  Box,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  Tooltip,
  DialogContentText,
  InputLabel,
  Select,
  CircularProgress,
  Backdrop,
} from "@mui/material";

import InfoOutlineIcon from '@mui/icons-material/InfoOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import PhotoIcon from '@mui/icons-material/Photo';
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Scrollbar } from "src/components/scrollbar";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { createFolder, setFolderId } from "../../redux/actions/FileFolder";
import { Link, useNavigate, useParams } from "react-router-dom";
import TableFolders from "./TableFolders";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import PlanFeatureComponent from "../planFeature/PlanFeatureComponent";

import { setAsapApkUpdate, setpdatePendingStatus, setUpdatePendingStatus, switchOfflineMode, unPairedScreen, updateScrceenScheduler } from "../../redux/actions/Screen";
import StayCurrentPortraitIcon from '@mui/icons-material/StayCurrentPortrait';
import StayCurrentLandscapeIcon from '@mui/icons-material/StayCurrentLandscape';
//icons
import SettingsIcon from '@mui/icons-material/Settings';
import CreateNewFolderOutlinedIcon from "@mui/icons-material/CreateNewFolderOutlined";
import AddToQueueIcon from "@mui/icons-material/AddToQueue";
import CreateNewFolderIcon from "@mui/icons-material/CreateNewFolder";
import DotsHorizontalIcon from "@untitled-ui/icons-react/build/esm/DotsHorizontal";
import EditIcon from "@mui/icons-material/Edit";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import WifiIcon from '@mui/icons-material/Wifi';
import SettingsEthernetIcon from '@mui/icons-material/SettingsEthernet';
import { Switch } from "@mui/material";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { getScreenWebviewIssues } from "src/utils/webviewCompat";
import { webviewIssueMessage } from "../webviewwarning/WebviewWarningDialog";
import { NetworkIcon } from "../../icons/untitled-ui/duocolor/network";
import BlockIcon from '@mui/icons-material/Block';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import currentVersionIcon from '../../icons/untitled-ui/apk-update-icons/current-ver.png'
import outdatedtVersionIcon from '../../icons/untitled-ui/apk-update-icons/outdated-ver.png'
import upgradingVersionIcon from '../../icons/untitled-ui/apk-update-icons/upgrading-ver.png'
import RefreshIcon from '@mui/icons-material/Refresh';

import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import UpdateAPKconfirmDialog from "../dialog/UpdateAPKconfirmDialog";
import ConfirmTurnOffApkUpdateStatusDialog from "../dialog/ConfirmTurnOffApkUpdateStatus";
import { api } from "src/api/endpoints";
import SelectSchedulerModal from "../selectfilesmodal/SelectSchedulerModal";
import ManageInactiveScreensDialog from "../dialog/ManageInactiveScreensDialog";
import ManageInactiveScreensInfo from "../dialog/ManageInactiveScreensInfo";

const useStyles = makeStyles((theme) => {
  return {
    chipStyling: {
      "&.MuiChip-root": {
        borderRadius: "2px",
        border: 0,
        height: { xl: "40px", lg: "30px", md: "20px", sm: "20px", xs: "20px" },
        width: { xl: "110px", lg: "80px", md: "80px", sm: "50px", xs: "50px" },
      },
    },
    chipOnlineColor: {
      background: "#D3FFE0",
    },
    chipOfflineColor: {
      background: "#FFD3D3",
    },
    tableHeaderFonts: {
      fontFamily: "Open Sans",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: "16px",
      lineHeight: "22px",
      letterSpacing: "-0.02em",
      color: "#15192C",
    },
  };
});

function TableBodies({
  dataRows,
  user,
  onUnpaired,
  onSyncScreen,
  onPaired,
  onFolderEdit,
  onScreenFolderDelete,
  onEditScreen,
  onScreenMove,
  onPairScreenModel,
  onQuickPairScreenModal,
  currentFolderData,
  currentFolderPoint,
  onPlaylistPreview,
  setScreenFilters,
  screenFilters,
  socketRef,
  setOpenQuickScreenPairModal,
  setOpenPairScreenModel,
  onOpenConnectedDevicesDialog,
  refresh,
  setPlayerv2
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const normalizeIsDisabled = (value) => value === true || value === 'true' || value === 1 || value === '1';
  const { currentFolder, allFolders, userFolders, screenFolders, isFolderDeleted } = useSelector(
    (state) => ({
      currentFolder: state.FileFolder.currentFolder,
      userFolders: state.FileFolder.userFolders.filter((f) => f.parent === state.FileFolder.currentFolder && f.folderFor === "screen"),
      allFolders: state.FileFolder.userFolders,
      screenFolders: state.FileFolder.userFolders.filter((f) => f.folderFor === "screen"),
      isFolderDeleted: state.FileFolder.isFolderDeleted
    }),
    shallowEqual
  );
  const { subscriptionsDetails:stripeCustomerData } = useSelector((state) => state.Subscription);
  const { apkVersions } = useSelector((state) => state.Apk)
  const { user : myUserData } = useSelector((state) => state.User);
//   console.log(Boolean(new Date(myUserData?.users[0]?.lastScreensSubUpdate).getTime() > new Date(myUserData?.users[0]?.lastScreenVisibilityChange || 0).getTime()))

  const { screensCount, setPendingStatusError } = useSelector((state) => state.Screen);
  const urlParams = new URLSearchParams(window.location.search);
  const [anchorEl, setAnchorEl] = useState(null);
  const imgMenuRef = useRef(null);
  const open = Boolean(anchorEl);
  const [docId, setDocId] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [openCreateFolder, setOpenCreateFolder] = useState(false);
  const [openNoAvailableScreensModal, setOpenNoAvailableScreensModal] = useState(false)

  const [openConfirmApkUpdateModal, setOpenConfirmApkUpdateModal] = useState({open: false, screen: null})
  const [openConfirmTurnOffApkUpdateStatusDialog, setOpenConfirmTurnOffApkUpdateStatusDialog] = useState({open: false, screen: null})
  const [openUnpairDialog, setOpenUnpairDialog] = useState({open: false, id: null})

  const [openSchedulerSelectorModal, setOpenSchedulerSelectorModal] = useState({screenId: null, open: false, loading: false})
  const [detachSchedulerConfirm, setDetachSchedulerConfirm] = useState({open: false, screenId: null, value: ''})

  const [openManageInActvScreens, setOpenManageInActvScreens] = useState(false)
  const [openManageInActvScreensInfo, setOpenManageInActvScreensInfo] = useState(false)

  const [disableScreensStatusSet, setDisableScreensStatusSet] = useState(false)

  const renderableRows = useMemo(() => {
    return dataRows
  }, [dataRows])

  const [displaySearchControls, setDisplaySearchControls] = useState(false)
  const [oneClick, setOneClick] = useState(false);

  const canManageInactiveScreens = myUserData?.users?.length > 0 ?  Boolean(
    new Date(myUserData?.users[0]?.lastScreensSubUpdate).getTime() >
      new Date(myUserData?.users[0]?.lastScreenVisibilityChange || 0).getTime()
  ) : false;

  useEffect(() => {
    const openBtn = document.querySelector("#openBtn");
    const closeBtn = document.querySelector("#closeBtn");
    const pagg = document.querySelector("#pagination-box");
    const btnGrp = document.querySelector("#btn-group");
    openBtn?.addEventListener("click", function (e) {
      btnGrp.classList.remove("hidden-rm");
      pagg.classList.remove("show-rm");
      pagg?.classList.add("hidden-rm");
      btnGrp.classList.add("show-rm");
    });
    closeBtn?.addEventListener("click", function (e) {
      pagg.classList.remove("hidden-rm");
      btnGrp.classList.remove("show-rm");
      pagg?.classList.add("show-rm");
      btnGrp.classList.add("hidden-rm");
    });
  }, []);

  useEffect(() => {
    if(setPendingStatusError) {
      toast.error(t("views.redesignScreens.updateStatusChangeError"))
    }
  }, [setPendingStatusError])

  const handleClose = (type, obj) => {
    setAnchorEl(null);
  };

    const emitOnDeleteScreen = (sid) => {
    // console.log(dataRows.find(d => d._id == id).mac)
    const id = setTimeout(() => {
      socketRef?.current.emit("screen_deleted", {
        detail: { mac: dataRows.find(d => d._id == sid).mac},
      });
      clearTimeout(id);
    }, 2000);
  };

    const handleUnpairScreen = () => {
      dispatch(unPairedScreen(openUnpairDialog.id));
      emitOnDeleteScreen(openUnpairDialog.id);
      setOpenUnpairDialog({open: false, id: null})
    }
  
    const getLatestApkVersion = () => {
      console.log(apkVersions)
      const sortedApkVersions = apkVersions.sort((vera, verb) => vera.verStr - verb.verStr)
      return sortedApkVersions[0]
    }

  const handleApkUpdate = (screen, apk) => {
    socketRef.current.emit("sendapkupdate", { url: apk?._doc?.apk?.uri, mac: screen.mac });
    dispatch(setUpdatePendingStatus(screen._id, true))
    setOpenConfirmApkUpdateModal({open: false, screen: null})
  }

  const handleTurnOffApkUpdatePendingStatus = (screen) => {
    setOpenConfirmTurnOffApkUpdateStatusDialog({open: false, screen: null})
    dispatch(setUpdatePendingStatus(screen._id, false))
  }

  const handleUpdateScreenScheduler = async (screenId, schedulerId) => {
    const res = await dispatch(updateScrceenScheduler({id: screenId, schedulerId: schedulerId, detachMode: false}))
    if(res) {
      socketRef.current.emit("sync", { detail: { mac: res.mac } });
      setOpenSchedulerSelectorModal({open: false, screenId: null, loading: false})
    }
  }

  const handleDetachScreenScheduler = async (screenId) => {
    const res = await dispatch(updateScrceenScheduler({id: screenId, schedulerId: null, detachMode: true}))
    if(res) {
      // console.log(res)
      socketRef.current.emit("sync", { detail: { mac: res.mac } });
      setOpenSchedulerSelectorModal({open: false, screenId: null, loading: false})
    }    
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }));

  const handleSetScreenFilterName = (e) => {
    e.preventDefault()
    if(e.target.querySelector("#screenNameInput").value.length) {
      setScreenFilters({...screenFilters, name: e.target.querySelector("#screenNameInput").value})
    }
  }

  const handleResetNameFilter = (e) => {
    e.preventDefault()
    e.target.querySelector("#screenNameInput").value = ''
    setScreenFilters({...screenFilters, name: ''})
    setDisplaySearchControls(false)

  }

  const makeFolder = async () => {
    // Check if folder name exists in current folders
    const isAvailable = false
    // allFolders.find((f) => f.name.toLocaleUpperCase() === folderName.toLocaleUpperCase());

    if (folderName === "") {
      toast.error(t("components.tableBodies.fillFolderNameField"));
    } else if (isAvailable) {
      toast.error(t("components.tableBodies.folderAlreadyAvailable"));
    } else {
      const folderData = {
        name: folderName,
        parent: currentFolder,
        folderFor: "screen",
        path: currentFolder === "root" ? [] : [...currentFolderData.path, { parent: currentFolder, name: currentFolderData.name }],
      };

      // Add specific properties based on user type
      if (user?.socialMedia) {
        Object.assign(folderData, {
          role: "socialMedia",
          platForm: "socialMedia",
          platFormId: user?._id,
        });
      } else {
        Object.assign(folderData, {
          role: user?.role,
          user: user?._id,
          subuser: user?._id,
        });
      }

      const folder = await dispatch(createFolder(folderData));
      // if (!folder) toast.error(t("components.tableBodies.folderAlreadyAvailable"));
    }

    setOpenCreateFolder(false);
    setFolderName("");
  };
  const handleNavigate = (link, id) => {
    dispatch(setFolderId(id));
    setScreenFilters({...screenFilters, folderId: id})
    return navigate(link);
  };

  const handlePairing = (id, mac, action) => {
    if (action === "unpair") {
      onUnpaired(id, mac);
    }
    if (action === "pair") {
      onPaired(id, mac);
    }
    handleClose();
  };

  const isMobile = useMediaQuery({ query: "(max-width: 786px)" });

  const tableStyle = {
    width: "100%",
    margin: "auto",
    border: "none",
    padding: isMobile ? 12 : 20,
    position: "relative",
  };
  const handleChangeOfflineMode = async (e, row) => {
    dispatch(switchOfflineMode(e.target.checked, row._id))
  };

  const canUserAddScreen = (type) => {
    if(stripeCustomerData){
      if(stripeCustomerData.subscriptions.data[0]?.items?.data?.find(si => si.planDetails?.name == 'Additional screen')){
        if(dataRows?.length < stripeCustomerData.subscriptions.data[0].items.data.find(si => si.planDetails?.name == 'Additional screen').quantity + Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value)){
          if(type == 'quick'){
            setOpenQuickScreenPairModal(true)
          }else if(type == 'advanced'){
            setOpenPairScreenModel(true)
          }
        }else {
          setOpenNoAvailableScreensModal(true)
        }
      }else{
        if(dataRows?.length < user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value){
          if(type == 'quick'){
            setOpenQuickScreenPairModal(true)
          }else if(type == 'advanced'){
            setOpenPairScreenModel(true)
          }
        }else{
          setOpenNoAvailableScreensModal(true)
        }
      }
    }else{
      if(dataRows?.length < user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value){
        if(type == 'quick'){
          setOpenQuickScreenPairModal(true)
        }else if(type == 'advanced'){
          setOpenPairScreenModel(true)
        }
      }else{
        setOpenNoAvailableScreensModal(true)
      }
    }
  }

  const handleSetAsapApkUpdate = (screenId, status) => {
    dispatch(setAsapApkUpdate(screenId, status))
  }

  const TableRowOld = ({ rows, unpair }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const isApkOutdated = (apkVersion) => {
        // console.log(apkVersions[0]._doc.versionCode)
        if (apkVersion) {
            if (apkVersion < Number(apkVersions[0]._doc.versionCode)){
                return true
            }else {
                return false
            }
        }else { return true }
    //   if(apkVersion && apkVersions?.length > 0){
    //     let noDotsApkVersion = apkVersion.split('.').join('')
    //     let apkVersionsToCheck = apkVersions

    //     if(`${apkVersionsToCheck[0].verStr}`.length > noDotsApkVersion.length){
    //       const zeroos = []
    //       for(let x = 0; x<`${apkVersionsToCheck[0].verStr}`.length - noDotsApkVersion.length; x++){
    //         zeroos.push('0')
    //       }
    //       noDotsApkVersion = Number(`${noDotsApkVersion}${zeroos.join('')}`)
    //     }else if(`${apkVersionsToCheck[0].verStr}`.length < noDotsApkVersion.length){
    //       const zeros = []
    //       for(let x = 0; x<noDotsApkVersion.length - `${apkVersionsToCheck[0].verStr}`.length; x++){
    //         zeros.push('0')
    //       }
    //       apkVersionsToCheck.map(v => {
    //         return {
    //           ...v,
    //           verStr: Number(`${v.verStr}${zeros.join('')}`)
    //         }
    //       })
    //     }
    //     const isApkOutdatedRes = apkVersionsToCheck?.find(v => noDotsApkVersion < v.verStr)
    //     if(isApkOutdatedRes){
    //       return true
    //     }else {
    //       return false
    //     }
    //   }else{
    //     return true
    //   }
    }

    console.log(isApkOutdated())

    const isRowDisabled = useMemo(() => normalizeIsDisabled(rows?.isDisabled), [rows?.isDisabled])
    const webviewIssues = useMemo(() => getScreenWebviewIssues(rows), [rows])

    const handleClose = (action, obj) => {
      if (action === "sync") {
        onSyncScreen(obj);
      }
      if (action === "moveinfolder") {
        onScreenMove(obj);
      }
      if (action === "screen-detail") {
        return navigate(`/screendetail/${obj}`);
      }
      if(action == 'unpair') {
        setOpenUnpairDialog({open: true, id: obj})
      }
      setAnchorEl(null);
    };
    // const handleChangeOfflineMode = () => {
    //   console.log("Updating screen status:", rows);
    //   const { _id, playlist, ...screen } = rows;

    //   dispatch(
    //     updateScreen(_id, {
    //       ...screen,
    //       playlistId: playlist?._id,
    //       offline_mode_enabled: !rows?.offline_mode_enabled,
    //     })
    //   );
    // };
    return (
      <>
        <TableRow sx={{
            position: "relative"
        }}>
          <TableCell>
            {isRowDisabled && (
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    zIndex: 100,
                    backgroundColor: "#000",
                    top: 0,
                    left: 0,
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    opacity: 0.9
                  }}
                >
                    <Typography variant="caption" color={"warning.main"} sx={{
                        mr: 3
                    }}>This screen is disabled</Typography>
                    <Tooltip title={"This screen is inactive, so it can't display any content. This status depends on available screens in current plan"}>
                        <InfoOutlineIcon sx={{
                            mr: 3
                        }} />
                    </Tooltip>
                    {!disableScreensStatusSet && (
                      <Tooltip title={canManageInactiveScreens ? "" : "You can switch screen status only once. Buy new screens to unlock this option."}>
                        <IconButton onClick={() => canManageInactiveScreens ? setOpenManageInActvScreens(true) : setOpenManageInActvScreensInfo(true)}>
                                <SettingsIcon />
                            </IconButton>
                        </Tooltip>
                    )}
                </Box>
            )}
            <Tooltip title={rows.deviceName.length > 30 ? rows.deviceName : ''} placement="right">
              {rows.deviceName.length > 30 ? `${rows.deviceName.slice(0, 30)}...` : rows.deviceName}
            </Tooltip>
          </TableCell>
          <TableCell align="center">
            {rows?.isOnline ? (
              rows?.isInOfflineMode ? (
                <Chip color="warning" label="OFF-LINE MODE" />
              ) : (
                <Chip color="success" label="ON-LINE" />
              )
            ) : (
              <Chip color="error" label="OFF-LINE" />
            )}
          </TableCell>
          <TableCell align="center">
            {rows?.locationDetails ? (
              rows?.locationDetails.fullLocation ? (
                !rows?.isOnline ? 'N/A' : (
                  <NetworkIcon ethernetStatus={rows?.device_details?.ethernetStatus} wifiSignal={rows?.device_details?.wifiSignal} connectionType={rows?.device_details?.connectionType}/>
                )
              ) : (
                <HtmlTooltip title={
                  <>
                  {t("components.tableBodies.notAccurateLocation")} &nbsp;
                  <span role="button" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate(`/screendetail/${rows?._id}`)}>set</span>
                  </>
                }>
                  <BlockIcon/>
                </HtmlTooltip>
              )
            ) : (
              <HtmlTooltip title={
                <>
                {t("components.tableBodies.locationNecessary")} &nbsp;
                <span role="button" style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={() => navigate(`/screendetail/${rows?._id}`)}>set</span>
                </>
              }>
                <BlockIcon/>
              </HtmlTooltip>
            ) }
          </TableCell>
          <TableCell align="center">{rows?.screenCode || "N/A"}</TableCell>
          <TableCell align="center" sx={{
            // display: "flex",
            // flexDirection: "column",
            // alignItems: "center"
          }}>
            {+rows?.device_details?.width > +rows?.device_details?.height ? <StayCurrentLandscapeIcon sx={{display: "block", margin: "0 auto"}} /> : <StayCurrentPortraitIcon sx={{display: "block", margin: "0 auto"}}  />}
            {
              rows?.device_details?.width+" x "+rows?.device_details?.height
            }
          </TableCell>
          <TableCell align="center">{rows?.user?.fullname || "N/A"}</TableCell>
          <TableCell align="center">
            <IconButton onClick={() => setPlayerv2({open: true, playlist: rows?.playlist})}>
              <SvgIcon>
                <SlideshowIcon color="primary" />
              </SvgIcon>
            </IconButton>
          </TableCell>

          {/* <TableCell align="center">{rows?.playlist?.playlistName || "N/A"}</TableCell> */}
          <TableCell align="center">
            {openSchedulerSelectorModal.loading ? (
              <CircularProgress size={24} />
            ) : rows?.scheduler?.name ? (
              <Tooltip title={rows?.scheduler?.name} placement="bottom">
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  position: 'relative',
                  minHeight: 40,
                  '&:hover .scheduler-actions': { opacity: 1, transform: 'translateY(-50%)' },
                  '&:hover .scheduler-chip': { opacity: 0 },
                }}
              >
                <Box sx={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center' }}>
                    <Chip
                      className="scheduler-chip"
                      label={rows?.scheduler?.name.length > 20 ? `${rows?.scheduler?.name.slice(0, 20)}...` : rows?.scheduler?.name}
                      sx={{
                        transition: 'opacity 0.15s ease',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)'
                      }}
                    />
                  <Box
                    className="scheduler-actions"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 0.5,
                      opacity: 0,
                      // transform: 'translateY(-50px)',
                      // transition: 'opacity 0.18s ease, transform 0.18s ease',
                      position: 'absolute',
                      // top: '50%',
                      // left: '50%',
                      transformOrigin: 'center',
                      // transform: 'translate(-50%, -50%)'
                    }}
                  >
                    <IconButton
                    disabled={isRowDisabled}
                      size="small"
                      onClick={() => setOpenSchedulerSelectorModal({ open: true, screenId: rows?._id })}
                      sx={{
                        backgroundColor: 'rgba(25,118,210,0.08)',
                        transition: 'background-color 0.2s',
                        '&:hover': { backgroundColor: 'rgba(25,118,210,0.18)' }
                      }}
                    >
                      <EditIcon color="primary" fontSize="small" />
                    </IconButton>
                    <IconButton
                    disabled={isRowDisabled}
                      size="small"
                      onClick={() => setDetachSchedulerConfirm({open: true, screenId: rows?._id, value: ''})}
                      sx={{
                        backgroundColor: 'rgba(211,47,47,0.08)',
                        transition: 'background-color 0.2s',
                        '&:hover': { backgroundColor: 'rgba(211,47,47,0.18)' }
                      }}
                    >
                      <DeleteIcon color="error" fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
              </Tooltip>
            ) : (
              // <Typography color={"text.disabled"}>{t("components.tableBodies.noScheduler")}</Typography>
              <Button size="small" disabled={isRowDisabled} onClick={() => setOpenSchedulerSelectorModal({ open: true, screenId: rows?._id })}>
                {t("components.tableBodies.assignScheduler")}
              </Button>
            )}
          </TableCell>
          <TableCell align="center">
            {webviewIssues.length > 0 ? (
              <Tooltip
                placement="bottom"
                title={
                  <Box>
                    {webviewIssues.map((issue, i) => (
                      <Typography key={`${issue.id}-${i}`} variant="caption" display="block">
                        {webviewIssueMessage(t, issue)}
                      </Typography>
                    ))}
                  </Box>
                }
              >
                <WarningAmberIcon color="warning" />
              </Tooltip>
            ) : (
            <Tooltip
            title={rows?.playlist?.playlistName || "N/A"} placement="bottom">
            {/* <Typography
                variant="caption"
                align="center"
                sx={{
                maxWidth: "200px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                margin: "0 auto",
                textAlign: "center",
                }}> */}
                {rows?.playlist?.playlistName.length > 30 ? `${rows?.playlist?.playlistName.slice(0, 30)}...` : rows?.playlist?.playlistName || "N/A"}
            {/* </Typography> */}
            </Tooltip>
            )}
          </TableCell>
          <TableCell align="center" sx={{maxWidth: '50px', minWidth: "100px"}}>{rows?.locationDetails ? (
            <Tooltip title={rows?.locationDetails?.formatted_address}>
              {rows?.locationDetails?.short_address?.replace("United States", "US").replace(" ", ', ')}
            </Tooltip>
          ) : (
            'N/A'
          )}</TableCell>
          <TableCell align="center">
            {user.isMember ? (
              user?.previlliages?.screen?.canEdit ? (
                <IconButton onClick={() => onEditScreen(rows)} disabled={isRowDisabled}>
                  <SvgIcon>
                    <EditIcon color="primary" />
                  </SvgIcon>
                </IconButton>
              ) : (
                <></>
              )
            ) : (
              <IconButton onClick={() => onEditScreen(rows)} disabled={isRowDisabled}>
                <SvgIcon>
                  <EditIcon color="primary" />
                </SvgIcon>
              </IconButton>
            )}
          </TableCell>
          <TableCell align="center">
            {rows.apkUpdatePending ? (
              <Tooltip placement="left" title={t("components.tableBodies.apkUpdatePendingInfo")}>
                {/* <Box component="button" onClick={() => handleSetAsapApkUpdate(rows?._id, false)} sx={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer'
                }}>
                  <Box component="img" sx={{
                    width: '25px',
                    height: '25px'
                  }} src={upgradingVersionIcon} alt="Apk update is pending" />
                </Box> */}
                <Box component='button' onClick={() => setOpenConfirmTurnOffApkUpdateStatusDialog({open: true, screen: rows})} sx={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer'
                }}>
                  <Box component="img" sx={{
                    width: '25px',
                    height: '25px'
                  }} src={upgradingVersionIcon} alt="Apk update is pending" />
                </Box>
              </Tooltip>
            ) : (
              isApkOutdated(rows?.device_details?.apkVersionCode) ? (
                <Tooltip placement="left" title={t("components.tableBodies.apkNeedsToBeUpdatedInfo")}>
                  <Box component="button" onClick={() => setOpenConfirmApkUpdateModal({open: true, screen: rows})} sx={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer'
                  }}>
                    <Box component="img" sx={{
                      width: '25px',
                      height: '25px'
                    }} src={outdatedtVersionIcon} alt="Apk needs to be updated" />
                  </Box>
                </Tooltip>
              ) : (
                <Tooltip placement="left" title={t("components.tableBodies.apkUpToDate")}>
                  <Box component="img" sx={{
                    width: '25px',
                    height: '25px'
                  }} src={currentVersionIcon} alt="Apk is up to date" />
                </Tooltip>
              )
            )}
          </TableCell>
          <TableCell align="center">
            <PlanFeatureComponent component={Switch} feature="screen_offline_mode" onChange={(e) => handleChangeOfflineMode(e, rows)} defaultChecked={rows?.offline_mode_enabled} />
          </TableCell>
          <TableCell align="center">
            <IconButton
              onClick={handleClick}
              aria-controls={open ? "content-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              id="content-menu-btn" disabled={isRowDisabled}>
              <SvgIcon>
                <DotsHorizontalIcon />
              </SvgIcon>
            </IconButton>

            <Menu
              id="content-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleClose}
              PaperProps={{
                elevation: 4,
                style: {
                  left: anchorEl?.offsetLeft,
                  top: anchorEl?.offsetTop + anchorEl?.offsetHeight,
                  position: "absolute",
                  display: Boolean(anchorEl) ? "block" : "none",
                },
              }}>
              {/* <MenuItem onClick={() => handleClose("unpair", rows._id)}>{t("components.tableBodies.unpair")}</MenuItem> */}
              <MenuItem onClick={() => handleClose("sync", rows.mac)}>{t("components.tableBodies.sync")}</MenuItem>
              <MenuItem onClick={() => handleClose("moveinfolder", rows._id)}>{t("components.tableBodies.move")}</MenuItem>
              <MenuItem onClick={() => handleClose("screen-detail", rows._id)}>{t("components.tableBodies.screenInfo")}</MenuItem>
            </Menu>
          </TableCell>
        </TableRow>
      </>
    );
  };

  return (
    <>
      <Box style={tableStyle}>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            position: "relative",
            flexDirection: isMobile ? "column" : "row",
          }}>
          {/* Breadcrumbs */}
          <div role="presentation" style={{ display: "flex", width: "100%", alignItems: "center" }}>
            {currentFolder !== "root" ? (
              <>
                {" "}
                <Button onClick={() => handleNavigate("/screen", "root")}>{t("components.tableBodies.home")}</Button>
                <Box
                  sx={{
                    backgroundColor: "neutral.500",
                    borderRadius: "50%",
                    height: 4,
                    width: 4,
                  }}
                />
                {currentFolderData?.path?.map((c, index) => (
                  <>
                    {" "}
                    <Button onClick={() => handleNavigate(`/screenfolders/${c.parent}`, `${c.parent}`)}>{c.name}</Button>
                    <Box
                      sx={{
                        backgroundColor: "neutral.500",
                        borderRadius: "50%",
                        height: 4,
                        width: 4,
                      }}
                    />
                  </>
                ))}
                <Typography sx={{ padding: "10px 10px" }} variant="button" display="block">
                  {currentFolderData?.name}
                </Typography>
              </>
            ) : (
              <Typography variant="button" display="block">
                {t("components.tableBodies.home")}
              </Typography>
            )}
          </div>
          {/* menu buttons */}
          <div
            role="presentation"
            style={{
              display: "flex",
              justifyContent: isMobile ? "flex-start" : "flex-end",
              width: "100%",
              flexWrap: "wrap",
              gap: "10px",
              marginTop: "10px",
            }}>
              {user?.role == 'admin' && (
                <Button variant="outlined" onClick={() => navigate('/screens-management')}>
                  Manage User's Screens
                </Button>
              )}
            &nbsp;
            <Button
              variant="outlined"
              onClick={() => canUserAddScreen('quick')}
              disabled={user.isMember ? (user?.previlliages?.screen?.canCreate ? false : true) : false}
              startIcon={<AddToQueueIcon />}>
              {t("components.tableBodies.quickAddScreen")}
            </Button>
            &nbsp;
            <Button
              variant="outlined"
              onClick={() => canUserAddScreen('advanced')}
              disabled={user.isMember ? (user?.previlliages?.screen?.canCreate ? false : true) : false}
              startIcon={<AddToQueueIcon />}>
              {t("components.tableBodies.addScreen")}
            </Button>
            &nbsp;
            {user.plan.planFeatures.find(pf => pf.slug == 'create_folders').enabled ? (
              <Button
                variant="outlined"
                onClick={() => setOpenCreateFolder(true)}
                startIcon={<CreateNewFolderOutlinedIcon />}>
                  {t("components.tableBodies.createGroup")}
              </Button>
            ) : null}
            {user?.role == 'admin' && (
                <Button variant="outlined" onClick={onOpenConnectedDevicesDialog}>
                Connected devices
                </Button>
            )}
          </div>
        </Box>

        {urlParams.get('playlistId') ? (
          <Typography color="warning.main" textAlign="center">Currently, only screens with one playlist are displayed <a href="/screen">Reset</a></Typography>
        ) : null}

        <Card sx={{ marginTop: "20px" }}>
          <Box
            sx={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              margin: "20px",
            }}>
            {userFolders.map((f, index) => {
              return <TableFolders key={index} folder={f} handleNavigate={handleNavigate} onFolderDelete={onScreenFolderDelete} onFolderEdit={onFolderEdit} />;
            })}
          </Box>
          <Box sx={{
            display: 'flex',
            gap: '40px',
            alignItems: 'center',
            flexWrap: 'wrap',
            p: '20px'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              maxWidth: '450px'
            }} component="form" onSubmit={(e) => handleSetScreenFilterName(e)} onReset={(e) => handleResetNameFilter(e)}>
              <TextField variant="outlined" type="text" label={t("components.tableBodies.findScreen")} placeholder={t("components.tableBodies.screenName")} fullWidth id="screenNameInput"  onInput={(e) => {
                e.target.value ? setDisplaySearchControls(true) : setDisplaySearchControls(false)
              }} />
              {displaySearchControls ? (
                <>
                  <IconButton type="submit"><SearchIcon color="primary" /></IconButton>
                  <IconButton type="reset"><CloseIcon color="error" /></IconButton>
                </>
              ) : null}
            </Box>
            <Box sx={{ minWidth: 200 }}>
              <FormControl fullWidth>
                <InputLabel id="status-select-label">{t("components.tableBodies.status")}</InputLabel>
                <Select
                  labelId="status-select-label"
                  id="status-select"
                  value={screenFilters.status}
                  label="Status"
                  onChange={(e) => setScreenFilters({...screenFilters, status: e.target.value})}
                >
                  <MenuItem value="all">{t("components.tableBodies.all")}</MenuItem>
                  <MenuItem value="online">{t("components.tableBodies.online")}</MenuItem>
                  <MenuItem value="offline_mode">{t("components.tableBodies.offlineMode")}</MenuItem>
                  <MenuItem value="offline">{t("components.tableBodies.offline")}</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <IconButton onClick={() => {
                screenFilters.page > 0 && setScreenFilters({...screenFilters, page: screenFilters.page-1})
              }}>
                <ArrowBackIosIcon/>
              </IconButton>
              <Typography variant="body1">{screenFilters.page+1}/{Math.floor(screensCount/10)+1}</Typography>
              <IconButton onClick={() => {
                screenFilters.page < Math.floor(screensCount/10) && setScreenFilters({...screenFilters, page: screenFilters.page+1})
              }}>
                <ArrowForwardIosIcon/>
              </IconButton>
            </Box>
            <IconButton color="primary" onClick={refresh}>
              <RefreshIcon fontSize="medium" />
            </IconButton>
          </Box>
          <Scrollbar>
            <Table sx={{ minWidth: 1750, width: "fill" }}>
              <TableHead>
                <TableRow>
                  <TableCell>{t("components.tableBodies.screenName")}</TableCell>
                  <TableCell sx={{ maxWidth: "6rem" }} align="center">
                    {t("components.tableBodies.status")}
                  </TableCell>
                  <TableCell align="center">{t("components.tableBodies.linktype")}</TableCell>
                  <TableCell align="center">{t("components.tableBodies.pairingCode")}</TableCell>
                  <TableCell align="center">{t("components.tableBodies.orientation")}</TableCell>
                  <TableCell align="center">{t("components.tableBodies.user")}</TableCell>
                  <TableCell align="center">
                    {t("components.tableBodies.preview")}
                  </TableCell>
                  <TableCell
                    align="center">
                    {t("components.tableBodies.playlistScheduler")}
                  </TableCell>
                  <TableCell
                    align="center">
                    {t("components.tableBodies.playlistName")}
                  </TableCell>                  
                  <TableCell align="center">{t("components.tableBodies.locationName")}</TableCell>
                  <TableCell align="center">
                    {t("components.tableBodies.edit")}
                  </TableCell>
                  <TableCell align="center">
                    APK
                  </TableCell>
                  <TableCell align="center">
                    {t("components.tableBodies.offlinemode")}
                  </TableCell>
                  <TableCell>
                    Propeties
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {renderableRows?.map((row, index) => (
                  <TableRowOld rows={row} key={index} unpair={(id, mac, action) => handlePairing(id, mac, action)} />
                ))}
                {/* <TableBody>
                {dataRows?.map((row, index) => (
                  <TableRowOld
                    rows={row}
                    key={index}
                    unpair={(id, mac, action) => handlePairing(id, mac, action)}
                    handleChangeOfflineMode={() => handleChangeOfflineMode(row)}
                  />
                ))} */}
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      </Box>

      {/* create group modal */}
      <Dialog open={openCreateFolder} onClose={() => setOpenCreateFolder(false)}>
        <FormControl component="form" onSubmit={(e) => e.preventDefault()}>
          <DialogTitle>{t("components.tableBodies.createGroup")}</DialogTitle>
          <DialogContent
            sx={{
              width: isMobile ? "300px" : "500px",
              height: "240px",
            }}>
            <Box style={{ width: "120px", height: "120px", margin: "20px auto" }}>
              <CreateNewFolderIcon color="primary" sx={{ fontSize: 120 }} />
            </Box>
            <TextField
              autoFocus
              required
              variant="standard"
              fullWidth
              margin="dense"
              id="folderName"
              name="folderName"
              type={"text"}
              label={t("components.tableBodies.typeFolderName")}
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenCreateFolder(false)}>{t("components.tableBodies.close")}</Button>
            <Button onClick={makeFolder} type="submit">
              {t("components.tableBodies.save")}
            </Button>
          </DialogActions>
        </FormControl>
      </Dialog>

      <Dialog open={openNoAvailableScreensModal} onClose={() => {setOpenNoAvailableScreensModal(false)}}>
        <DialogTitle>{t("components.tableBodies.noAvailableScreens")}</DialogTitle>
        <DialogContent sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3
        }}>
          <Button variant="contained" onClick={() => {
            if(user.plan.paid){
              navigate(`/user-details/${user?._id}#mysubscriptions`)
            }else{
              navigate(`/user-details/${user._id}#mysubscriptionsfl`)
            }
          }}>{t("components.tableBodies.buyScreensButton")}</Button>
        </DialogContent>
        <DialogActions>
          <Button color="error" onClick={() => {setOpenNoAvailableScreensModal(false)}}>{t("components.tableBodies.close")}</Button>
        </DialogActions>
      </Dialog>

      <Dialog 
        maxWidth="sm"
        fullWidth
        open={openUnpairDialog.open}
        onClose={() => setOpenUnpairDialog({open: false, id: null})}
      >
        <DialogTitle textAlign={"center"} sx={{
          mt: 3
        }}>{t("views.redesignScreens.unpairConfirmQuestion")}</DialogTitle>
        <DialogContent>
          <DialogContentText textAlign="center">
            {t("views.redesignScreens.unpairConfirmComment")}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{
          display: "flex",
          justifyContent: "center",
          mb: 3
        }}>
          <Button variant="contained" color="error" onClick={handleUnpairScreen}>Unpair</Button>
          <Button variant="contained" onClick={() => setOpenUnpairDialog({open: false, id: null})}>Cancel</Button>
        </DialogActions>
      </Dialog>

      

      <UpdateAPKconfirmDialog open={openConfirmApkUpdateModal.open} setOpen={setOpenConfirmApkUpdateModal} screen={openConfirmApkUpdateModal.screen} latestVersion={getLatestApkVersion()} onUpdate={handleApkUpdate}/>
      <ConfirmTurnOffApkUpdateStatusDialog open={openConfirmTurnOffApkUpdateStatusDialog.open} setOpen={setOpenConfirmTurnOffApkUpdateStatusDialog} onConfirm={handleTurnOffApkUpdatePendingStatus} screen={openConfirmTurnOffApkUpdateStatusDialog.screen}  /> 
      <SelectSchedulerModal open={openSchedulerSelectorModal.open} onClose={() => setOpenSchedulerSelectorModal({screenId: null, open: false})} onSelectScheduler={(schedulerId) => handleUpdateScreenScheduler(openSchedulerSelectorModal.screenId, schedulerId._id)} />
      <ManageInactiveScreensDialog setDisableScreensStatusSet={setDisableScreensStatusSet} open={openManageInActvScreens} setOpen={setOpenManageInActvScreens} screens={renderableRows.map(r => {
        return {
            _id: r._id,
            isDisabled: normalizeIsDisabled(r.isDisabled),
            name: r.deviceName
        }
      })} availableScreens={stripeCustomerData ? stripeCustomerData.subscriptions.data[0]?.items?.data?.find(si => si.planDetails?.name == 'Additional screen') ? 
                        stripeCustomerData.subscriptions.data[0].items.data.find(si => si.planDetails?.name == 'Additional screen').quantity + Number(user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value) : user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value : user?.plan?.planFeatures?.find(pf => pf.slug == 'max_screens').value} />
      <ManageInactiveScreensInfo open={openManageInActvScreensInfo} setOpen={setOpenManageInActvScreensInfo} user={user} />
      <Dialog
        open={detachSchedulerConfirm.open}
        onClose={() => setDetachSchedulerConfirm({open: false, screenId: null, value: ''})}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle>Confirm Scheduler Detach</DialogTitle>
        <DialogContent sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px"
        }}>
          <DialogContentText>
            Type "delete" to detach scheduler from this screen.
          </DialogContentText>
          <TextField
            fullWidth
            label="Type delete to confirm"
            value={detachSchedulerConfirm.value}
            onChange={(e) => setDetachSchedulerConfirm({...detachSchedulerConfirm, value: e.target.value})}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDetachSchedulerConfirm({open: false, screenId: null, value: ''})}>Cancel</Button>
          <Button
            color="error"
            disabled={detachSchedulerConfirm.value.trim().toLowerCase() !== 'delete'}
            onClick={() => {
              handleDetachScreenScheduler(detachSchedulerConfirm.screenId);
              setDetachSchedulerConfirm({open: false, screenId: null, value: ''});
            }}
          >Detach</Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default TableBodies;
